import { Box, CircularProgress, Container } from "@mui/material";
import { useEffect, useState } from "react";
import BannerBlock from "../../components/BannerBlock";
import Questions360Section from "../../components/Questions360Section";
import { useParams } from "react-router-dom";
import { getAnswersByBlock360, getUserEvalInfo } from "../../axios/axiosFunctions";
import { loadAnswerDraft } from "../../utils/answerDraft";

const Assessment360Block = ({currentBlock,buttonsDir,changeTab,setCurrentBlock}) => {
  
  const {userEvalId,userId,groupId} = useParams();
  const [currentAnswers, setCurrentAnswers] = useState([]);
  const [userEvalInfo, setUserEvalInfo] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if(currentBlock){
      const requestAnswers = async()=>{
          const res =  await getAnswersByBlock360(currentBlock._id,userId,userEvalId);
          const saved = res?.answers || [];
          // Nothing saved yet: bring back whatever they typed before (closed tab, failed save)
          const draft = saved.length === 0 ? loadAnswerDraft({userId,userEvalId,groupId,blockId:currentBlock._id}) : null;
          setCurrentAnswers(draft || saved);
      }
      const callUserInfo = async()=>{
        const res = await getUserEvalInfo(userEvalId);
        setUserEvalInfo(res.user);
        setLoading(false);
      }
      callUserInfo();
      requestAnswers();
    }
  }, [currentBlock])

  return (
  <Container maxWidth="false" sx={{padding:"0px !important"}}>
      <BannerBlock name={currentBlock?.name} color={currentBlock?.color}/>
      <Box display="flex" flexDirection="column" alignItems="center">
          {
            loading && <CircularProgress/>
          }
          {
            !loading &&
            <Questions360Section blockId={currentBlock._id} questions={currentBlock?.questions} color={currentBlock?.color} buttonsDir={buttonsDir} changeTab={changeTab} setCurrentBlock={setCurrentBlock} 
            currentAnswers={currentAnswers} setCurrentAnswers={setCurrentAnswers} userEvalInfo={userEvalInfo}/>
          }
      </Box>
  </Container>
)
}

export default Assessment360Block